// extracted by mini-css-extract-plugin
export default {"brandPromo":"vH-z","carousel":"wH-z"};